import React from 'react';
import { ChevronRight } from 'lucide-react';

const inr = (n) => `₹${Math.round(n).toLocaleString('en-IN')}`;
const RANK_COLORS = ['#6d28d9', '#0ea5e9', '#16a34a']; // accent for the top 3

// rows: [{ id, name, regs, paid, revenue, share }]
// onRowClick(id): navigate to that event.
const TopEventsTable = ({ rows = [], onRowClick }) => {
  if (rows.length === 0) {
    return <div className="py-6 text-center text-sm text-slate-400 font-jakarta">No events yet</div>;
  }
  return (
    <div>
      {rows.map((r, i) => (
        <button
          key={r.id}
          type="button"
          onClick={() => onRowClick && onRowClick(r.id)}
          className="group w-full text-left flex items-center gap-3 py-2.5 px-2 -mx-2 rounded-lg border-b last:border-b-0 hover:bg-slate-50 transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30"
          style={{ borderColor: '#f6f8fb' }}
        >
          {/* Rank */}
          <span
            className="w-6 h-6 rounded-md flex items-center justify-center text-[11px] font-bold shrink-0 font-outfit"
            style={{
              background: i < 3 ? `${RANK_COLORS[i]}1a` : '#f1f5f9',
              color: i < 3 ? RANK_COLORS[i] : '#94a3b8',
            }}
          >
            {i + 1}
          </span>

          {/* Name + share bar + sub-stats */}
          <div className="flex-1 min-w-0">
            <div className="text-xs font-semibold text-slate-800 truncate font-jakarta group-hover:text-primary" title={r.name}>
              {r.name}
            </div>
            <div className="flex items-center gap-2 mt-1">
              <div className="rounded-full h-1.5 flex-1 max-w-[180px] overflow-hidden" style={{ background: '#eef2ff' }}>
                <div className="h-full rounded-full" style={{ width: `${Math.max(0, Math.min(100, r.share || 0))}%`, background: '#6d28d9' }} />
              </div>
              <span className="text-[10px] text-slate-400 font-jakarta whitespace-nowrap">{r.regs} regs · {r.paid} paid</span>
            </div>
          </div>

          {/* Revenue + chevron */}
          <div className="text-xs font-bold text-slate-900 font-outfit shrink-0">{inr(r.revenue)}</div>
          <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-primary shrink-0" />
        </button>
      ))}
    </div>
  );
};

export default TopEventsTable;
